var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEasxLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50.6 73.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{opacity:0.7;}.cls-1{fill:url(#Unbenannter_Verlauf_2);}.cls-2{fill:url(#Unbenannter_Verlauf_3);}.cls-3{fill:url(#Unbenannter_Verlauf_4);}.cls-4{fill:url(#Unbenannter_Verlauf_3-2);}.cls-5{fill:#d6d6d6;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_2",
    x1: 278.09,
    y1: 1401.66,
    x2: 239.63,
    y2: 1401.14,
    gradientTransform: "translate(-236.35 -1364.51)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e8e8e8",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#dcdcdc",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#ccc",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#b7b7b7",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#9d9d9d",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#7e7e7e",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5a5a5a",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#323232",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3",
    x1: 244.51,
    y1: -1488.5,
    x2: 259.51,
    y2: -1488.5,
    gradientTransform: "translate(1514.94 258.14) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#e8e8e8",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#ddd",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#cdcdcd",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#b8b8b8",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9e9e9e",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7f7f7f",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#5c5c5c",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#353535",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_4",
    x1: 1070.83,
    y1: -1981.02,
    x2: 1032.37,
    y2: -1981.02,
    gradientTransform: "translate(-1045.54 2017.95)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#eee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#e8e8e8",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dcdcdc",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#ccc",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#b7b7b7",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#9d9d9d",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#7e7e7e",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#5a5a5a",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323232",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262626",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_3-2",
    x1: -676.21,
    y1: 2055.95,
    x2: -661.21,
    y2: 2055.95,
    gradientTransform: "translate(2063.45 736.47) rotate(90)",
    xlinkHref: "#Unbenannter_Verlauf_3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 7.21,
    y: 29.44,
    width: 38.46,
    height: 15,
    rx: 7.5,
    transform: "translate(-10.5 63.38) rotate(-90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 26.44,
    cy: 7.5,
    r: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: -11.73,
    y: 29.43,
    width: 38.46,
    height: 15,
    rx: 7.5,
    transform: "translate(44.43 29.43) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 7.5,
    cy: 66.37,
    r: 7.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M39.78,10.08V0h8.93V2.57H42.6v1.2h5.88V6.29H42.6V7.55h6.11v2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M37.88,25.36l4.34-10h4l4.35,10H47.36L46.6,23.5H41.83l-.78,1.86Zm5-4.4h2.67L45,19.55l-.66-1.69h-.2l-.64,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M38.09,56.17,41.89,51v-.21l-3.8-5.17h3.69L44.21,49h.2l2.29-3.42h3.69l-3.78,5.23v.21l3.78,5.12H46.7l-2.41-3.43h-.2l-2.31,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.41,29.61c2.92,0,4.9,1.24,4.9,3.6v.45H46v-.45c0-.64-.56-1.06-1.64-1.06h-.22c-1.1,0-1.66.35-1.66.77v.19c0,.59.45.83,2.86,1.34,2.85.68,4.12,1.67,4.12,3.58v.17c0,1.94-1.62,3.41-5.06,3.41h-.28c-3.43,0-5.15-1.51-5.15-3.88v-.38h3.29v.4c0,1,.69,1.31,1.89,1.31h.23c1.13,0,1.77-.3,1.77-.82v-.12c0-.54-.64-.87-3.14-1.41s-3.85-1.55-3.85-3.41V33c0-2.19,1.86-3.41,4.94-3.41Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasxLogoDark);
export default __webpack_public_path__ + "static/media/EASX_Logo_Dark.a22f191c1917c3b2f190541631da1a99.svg";
export { ForwardRef as ReactComponent };